export enum DriveUploadStatus {
    READY_FOR_UPLOAD = 'READY_FOR_UPLOAD',
    IN_PROGRESS = 'IN_PROGRESS',
    SUCCESS = 'SUCCESS',
    FAILED = 'FAILED'
}
